/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteIntegrationResponse } from '../../models/delete-integration-response';

export interface DeleteIntegration$Params {
  integration_id: string;
}

export function deleteIntegration(http: HttpClient, rootUrl: string, params: DeleteIntegration$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteIntegrationResponse>> {
  const rb = new RequestBuilder(rootUrl, deleteIntegration.PATH, 'delete');
  if (params) {
    rb.path('integration_id', params.integration_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteIntegrationResponse>;
    })
  );
}

deleteIntegration.PATH = '/integrations/{integration_id}';
